import { useState } from 'react';

import { TFlatBlock } from './helpers/blocksToFlatDocument';

export type TBlockStatus = {
  id: string;
  index: number;
  flatBlock: TFlatBlock;
};

export default function useBlockState() {
  return useState<TBlockStatus | null>(null);
}
